const $body = $('body'),
    classModalVisible = 'modal--visible',
    classBodyModalVisible = 'show-modal';


// modal toggles added via shortcode links
$('[data-toggle="frame-modal"]').on('click', function (e) {
    e.preventDefault();

    let url = $(this).attr('href'),
        title = $(this).attr('title'),
        modalID = $(this).attr('data-modal-id');

    let modalHTML = '<div class="modal" data-modal-id="'+ modalID +'">' +
            '<h3 class="modal__title">'+ title +'</h3>' +
            '<button type="button" class="modal__close"><i class="fal fa-times"></i></button>' +
            '<div class="modal__body">' +
            '<div class="modal__scroll-container">' +
            '<iframe src="'+ url +'" class="modal__frame"></iframe>' +
            '</div>' +
            '</div>' +
            '</div>';

    if ($('.modals .modals__wrapper').length > 0) {
        if (!$('[data-modal-id="'+ modalID +'"]').length > 0) {
            $('.modals .modals__wrapper').append(modalHTML);
        }
    } else {
        $body.append('<div class="modals"><div class="modals__wrapper">'+ modalHTML +'</div></div>');
    }

    $('[data-modal-id="'+ modalID +'"]').trigger('open-modal');
});


// open modal action
$body.on('open-modal', '.modals .modal', function() {
    let $modal = $(this);

    // check if cookie exists for this modal - if so, dont show
    if ($modal.hasClass('modal--has-cookie')) {
        let cookieHash = 'modal_'+ $modal.data('cookie-hash');

        if (Cookies.get(cookieHash)) {
            return;
        }
    }

    if (!$body.hasClass(classBodyModalVisible)) {
        $body.addClass(classBodyModalVisible);
    }

    $('.modals').stop().fadeIn(150, 'easeInOutCubic', function() {
        let showDelay = 0;

        // close already open modals
        if ($('.modal.'+classModalVisible).length > 0) {
            showDelay = 150;

            $('.modal.' + classModalVisible).each(function () {
                let $visibleModal = $(this);

                $visibleModal.removeClass(classModalVisible);

                setTimeout(function () {
                    $visibleModal.hide();
                }, 150);
            });
        }

        setTimeout(function () {
            $modal.show();

            setTimeout(function() {
                $modal.addClass(classModalVisible);
            }, 100);
        }, showDelay);
    });
});


// close modal action
$body.on('close-modal', '.modals .modal', function() {
    let $modal = $(this);

    if ($body.hasClass(classBodyModalVisible)) {
        $body.removeClass(classBodyModalVisible);
    }

    $modal.removeClass(classModalVisible);

    setTimeout(function() {
        $('.modals').stop().fadeOut( 150, 'easeInOutCubic', function() {
            $modal.hide();
        });
    }, 150 );

    // set cookie if needed
    if ($modal.hasClass('modal--has-cookie')) {
        let duration = $modal.data('cookie-duration'),
            cookieHash = 'modal_'+ $modal.data('cookie-hash'); // based on modal content, so if content changes modal will be shown again

        if (typeof duration !== 'undefined' && typeof cookieHash !== 'undefined') {
            setCookie(cookieHash, 1, duration);
        }
    }
});


// regular modal toggles
$('[data-toggle="modal"]').on('click', function(e) {
    e.preventDefault();

    let modalID = $(this).data('modal-id');

    $('[data-modal-id="'+ modalID +'"]').trigger('open-modal');
});


// auto show modals
$('.modal.modal--auto-show').each(function () {
    let $modal = $(this),
        delay = $modal.data('modal-delay');

    if (typeof delay == 'undefined') {
        delay = 0;
    }

    setTimeout(function() {
        $modal.trigger('open-modal');
    }, delay);
});


// close modal buttons
$body.on('click', '.modal__close, .modal__footer .btn', function () {
    $(this).closest('.modal').trigger('close-modal');
});


$(document).on('click', function(e) {
    // close modals when clicking outside window
    if ( ! $(e.target).closest('.modal').length > 0 ) {
        $('.modals .modal.modal--visible').trigger('close-modal');
    }
});
